/** Optional visual progress for a native Horizon carousel; scrolling remains Horizon-owned. */
class CarouselProgress extends HTMLElement {
  #observer;
  #events;
  #frame;
  connectedCallback() {
    const events = new AbortController();
    this.#events = events;
    queueMicrotask(() => {
      if (!this.isConnected || events.signal.aborted) return;
      const scroller = this.querySelector('slideshow-slides, [data-carousel-progress-scroller]');
      const track = this.querySelector('.carousel-progress__track');
      if (!scroller || !track) return;
      const update = () => {
        const total = scroller.scrollWidth;
        const visible = scroller.clientWidth;
        const max = total - visible;
        track.hidden = max <= 1;
        const offset = Math.min(Math.max(max, 0), Math.max(scroller.scrollLeft, 0));
        const fill = total > 0 ? Math.min(1, (visible + offset) / total) : 1;
        track.style.setProperty('--carousel-progress-fill', String(fill));
      };
      const schedule = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(update);
      };
      scroller.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
      this.#observer = new ResizeObserver(schedule);
      this.#observer.observe(scroller);
      for (const slide of scroller.children) this.#observer.observe(slide);
      update();
    });
  }
  disconnectedCallback() {
    this.#events?.abort();
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
  }
}
if (!customElements.get('carousel-progress')) customElements.define('carousel-progress', CarouselProgress);
